// extracted by mini-css-extract-plugin
export default {"root":"styles_root__3yfUg","block":"styles_block__bbxhO","s":"styles_s__GTJdk","m":"styles_m__Lh66n","l":"styles_l__nAVk1","xl":"styles_xl__6XzjL"};